import axios from 'axios'

const baseUrl = process.env.VUE_APP_BASE_URL
// let baseUrl = 'https://competitions-test.juicydata.es/api/v1/'

// if (window.location.pathname === '/landing_co_dev/') {
//   baseUrl = 'https://competitions-test.juicydata.es/api/v1/'
// } else if (window.location.pathname === '/landing_co/') {
//   baseUrl = 'https://participa.barmanagerapp.com/api/v1/'
// }

const apiClient = axios.create({
  baseURL: baseUrl,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

// const apiMockClient = axios.create({
//   baseURL: 'http://localhost:3000',
//   withCredentials: false,
//   transitional: {
//     silentJSONParsing: false
//   },
//   responseType: 'json',
//   headers: {
//     Accept: 'application/json',
//     'Content-Type': 'multipart/form-data'
//   }
// })

export default {

  // getAvailableContestMock (aliasUrl) {
  //   return apiMockClient.get('getAvailableContest')
  // },

  getAvailableContest (params) {
    return apiClient.post('getContestsWithoutSSOData', {
      alias_url: params.alias_url,
      preview: params.preview === 'preview' ? 1 : 0
    })
  },

  // getAPIParticipantsDataMock (aliasUrl) {
  //   return apiMockClient.get('getContestsParticipantsWithoutSSOData', {
  //     alias_url: aliasUrl
  //   })
  // },

  getAPIParticipantsData (params) {
    return apiClient.post('getContestsParticipantsWithoutSSOData', {
      alias_url: params.alias_url,
      preview: params.preview === 'preview' ? 1 : 0
    })
  },

  getParticipationId (params) {
    return apiClient.post('getParticipationDataByID', {
      _id: params.videoId,
      alias_url: params.alias_url,
      preview: params.preview === 'preview' ? 1 : 0
    })
  },

  registerAPI (data) {
    return apiClient.post('signupFromLanding', data)
  },

  verifyAccountAPI (data) {
    return apiClient.post('verifyAccountFromLanding', data)
  },

  deleteAccountAPI (data) {
    return apiClient.post('unsuscribeFromLanding', data)
  },

  loginAPI (data) {
    return apiClient.post('loginFromLanding', data)
  },

  verifyCodeAPI (data) {
    return apiClient.post('verifyLoginFromLanding', data)
  },

  updateVote (params) {
    const data = params.data
    const token = params.token
    return apiClient.post('updateVoteParticipationFromLanding',
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
  }

}
